import { render, staticRenderFns } from "./appointment_hours.vue?vue&type=template&id=465f6611"
import script from "./appointment_hours.vue?vue&type=script&lang=js"
export * from "./appointment_hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports